import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { handlesGroup as r } from "../handleUtils.js";
import { clone as n } from "../lang.js";
import { assumeNonNull as t } from "../maybe.js";

function e(r) {
  return r ? r.__accessor__ ? r.__accessor__ : r.propertyInvalidated ? r : null : null;
}

function i(r, n) {
  return null != r && r.metadatas && null != r.metadatas[n];
}

function o(r, n) {
  var t = e(r);
  return t ? t.getDependsInfo(r, n, "") : "";
}

function u(r, n, t) {
  if (t) {
    return a(r, n, {
      policy: t,
      path: ""
    });
  }

  return a(r, n, null);
}

function a(r, e, i) {
  return e ? Object.keys(e).reduce(function (r, o) {
    var u = null,
        l = "merge";
    if (i && (u = i.path ? "".concat(i.path, ".").concat(o) : o, l = i.policy(u)), "replace" === l) return r[o] = e[o], r;
    if (void 0 === r[o]) return r[o] = n(e[o]), r;
    var f = r[o],
        s = e[o];
    if (f === s) return r;
    if (Array.isArray(s) || Array.isArray(r)) f = f ? Array.isArray(f) ? r[o] = f.concat() : r[o] = [f] : r[o] = [], s && (Array.isArray(s) || (s = [s]), s.forEach(function (r) {
      -1 === f.indexOf(r) && f.push(r);
    }));else if (s && "object" == typeof s) {
      if (i) {
        var _n = i.path;
        i.path = t(u), r[o] = a(f, s, i), i.path = _n;
      } else r[o] = a(f, s, null);
    } else r.hasOwnProperty(o) && !e.hasOwnProperty(o) || (r[o] = s);
    return r;
  }, r || {}) : r;
}

function l(r) {
  return r ? "string" == typeof r && -1 === r.indexOf(".") ? r : f(r) : r;
}

function f(r) {
  return Array.isArray(r) ? r : r.split(".");
}

function s(r) {
  return r.indexOf(",") > -1 ? r.split(",").map(function (r) {
    return r.trim();
  }) : [r.trim()];
}

function c(r) {
  if (Array.isArray(r)) {
    var _n2 = [];

    var _iterator = _createForOfIteratorHelper(r),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _t = _step.value;

        _n2.push.apply(_n2, _toConsumableArray(s(_t)));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return _n2;
  }

  return s(r);
}

function p(r) {
  if (-1 === r.indexOf("?")) return null;
  var n = f(r),
      t = new Array(n.length);

  for (var _e = 0; _e < n.length; _e++) {
    var _r = n[_e];
    t[_e] = "?" === _r[_r.length - 1], t[_e] && (n[_e] = _r.slice(0, -1));
  }

  return {
    fullPath: n.join("."),
    conditional: t
  };
}

function y(n, t, e, i) {
  var o = c(t);

  if (1 !== o.length) {
    var _t2 = o.map(function (r) {
      return i(n, r, e);
    });

    return r(_t2);
  }

  return i(n, o[0], e);
}

function h(r) {
  var n = !1;
  return function () {
    n || (n = !0, r());
  };
}

export { o as getDependsInfo, e as getProperties, i as isPropertyDeclared, u as merge, h as once, y as parse, p as parseConditionalPath, f as pathToArray, l as pathToStringOrArray, c as splitPath };